import { useAuthStore } from "@/features/auth";
import { ChatComponent } from "@/features/chat/ui";
import { connectWS, getSocket } from "@/processes/socket";
import { useEffect } from "react";

export default function Home() {
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && user?._id) {
      connectWS(token, user._id);

      return () => {
        getSocket()?.disconnect();
      };
    }
  }, [user?._id]);

  return (
    <div style={{ position: "relative", padding: 12, height: "100%" }}>
      <ChatComponent />
    </div>
  );
}
